module.exports = __webpack_public_path__ + "static/img/fullscreen-image_keep-on-top_768.528a72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_keep-on-top_768.png
// module id = kIro
// module chunks = 0